(()=>{
  if(window.__bpcCurrencyEngineLoaded)return;
  window.__bpcCurrencyEngineLoaded=true;

  const config=document.querySelector('[data-bpc-currency-engine]');
  if(!config)return;

  const currency=String(config.dataset.bpcCurrency||'USD').toUpperCase();
  const buffer=Number(config.dataset.bpcBuffer||'1.03');
  const ttlHours=Number(config.dataset.bpcCacheHours||'24');
  const ttlMs=(Number.isFinite(ttlHours)&&ttlHours>0?ttlHours:24)*60*60*1000;
  const staleMaxMs=7*24*60*60*1000;
  const validCurrency=/^[A-Z]{3}$/.test(currency);
  const zeroDecimal=new Set(['JPY','KRW']);
  const state={currency,buffer:Number.isFinite(buffer)&&buffer>=1&&buffer<=1.2?buffer:1.03,rate:null,ready:false,rateDate:null,provider:null};
  const cacheKey=`bpcFxDaily:v3:USD:${currency}`;
  const apiBase='https://api.frankfurter.dev/v2/rate/USD/';
  let observer=null;
  let renderQueued=false;
  let rendering=false;
  let pendingCheckout=null;

  const parseMoney=(text)=>{
    const cleaned=String(text||'').replace(/[^0-9.,-]/g,'');
    if(!cleaned)return null;
    const decimalComma=cleaned.lastIndexOf(',')>cleaned.lastIndexOf('.');
    const normalized=decimalComma?cleaned.replace(/\./g,'').replace(',','.'):cleaned.replace(/,/g,'');
    const value=Number(normalized);
    return Number.isFinite(value)?value:null;
  };

  const formatLocal=(value)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{
    style:'currency',
    currency,
    minimumFractionDigits:zeroDecimal.has(currency)?0:2,
    maximumFractionDigits:zeroDecimal.has(currency)?0:2
  }).format(zeroDecimal.has(currency)?Math.round(value):Math.round(value*100)/100);

  const formatUsd=(value)=>new Intl.NumberFormat('en-US',{
    style:'currency',currency:'USD',minimumFractionDigits:2,maximumFractionDigits:2
  }).format(Math.round(value*100)/100)+' USD';

  const localFromUsd=(usd)=>usd*state.rate*state.buffer;

  const validRate=(value)=>Number.isFinite(Number(value))&&Number(value)>0.000001&&Number(value)<1000000;

  const readCache=()=>{
    try{
      const cached=JSON.parse(localStorage.getItem(cacheKey)||'null');
      if(!cached||!validRate(cached.rate)||!Number.isFinite(Number(cached.savedAt)))return null;
      return cached;
    }catch(error){return null;}
  };

  const saveCache=(payload)=>{
    try{localStorage.setItem(cacheKey,JSON.stringify(payload));}catch(error){}
  };

  const fetchJson=async(url)=>{
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),6000);
    try{
      const response=await fetch(url,{
        method:'GET',mode:'cors',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',
        headers:{Accept:'application/json'},signal:controller.signal
      });
      if(!response.ok)throw new Error('FX response not OK');
      return await response.json();
    }finally{clearTimeout(timeout);}
  };

  const fetchRate=async()=>{
    const encoded=encodeURIComponent(currency);
    const urls=[`${apiBase}${encoded}?providers=ECB`,`${apiBase}${encoded}`];
    let lastError=null;
    for(const url of urls){
      try{
        const data=await fetchJson(url);
        if(!data||String(data.base||'USD').toUpperCase()!=='USD'||String(data.quote||currency).toUpperCase()!==currency||!validRate(data.rate))throw new Error('Invalid FX payload');
        return {rate:Number(data.rate),savedAt:Date.now(),rateDate:data.date||null,provider:url.includes('providers=ECB')?'ECB':'Frankfurter'};
      }catch(error){lastError=error;}
    }
    throw lastError||new Error('FX unavailable');
  };

  const priceKey=(cents)=>`${cents}:${state.rate}:${state.buffer}:${currency}`;

  const renderPriceItem=(element)=>{
    if(element.closest('.cart-item,.cart-drawer,.drawer,.bpc-currency-modal,.unit-price'))return;
    const cents=Number(element.dataset.bpcUsdCents);
    if(!Number.isFinite(cents)||cents<0)return;
    const from=element.dataset.bpcPriceFrom==='true';
    const text=(from?'From ':'')+formatLocal(localFromUsd(cents/100));
    const key=priceKey(cents)+(from?':from':'');
    if(element.dataset.bpcFxKey===key&&element.textContent.trim()===text)return;
    element.textContent=text;
    element.dataset.bpcFxKey=key;
    element.setAttribute('aria-label',`${from?'From ':''}${formatLocal(localFromUsd(cents/100))}, estimated local price`);
  };

  const visibleProductPrice=(root)=>{
    if(root.classList.contains('price--on-sale'))return root.querySelector('.price__sale .price-item--sale[data-bpc-usd-cents]');
    return root.querySelector('.price__regular .price-item--regular[data-bpc-usd-cents]');
  };

  const renderProductHierarchy=()=>{
    document.querySelectorAll('.product__info-container').forEach((container)=>{
      const root=container.querySelector('[id^="price-"] .price--large,.price--large');
      if(!root)return;
      const visible=visibleProductPrice(root);
      if(!visible)return;
      const cents=Number(visible.dataset.bpcUsdCents);
      if(!Number.isFinite(cents)||cents<0)return;
      const key=priceKey(cents);
      let label=root.querySelector('.bpc-product-price-approx-label');
      if(!label){
        label=document.createElement('span');
        label.className='bpc-product-price-approx-label';
        label.textContent='Approx.';
        visible.insertAdjacentElement('beforebegin',label);
      }
      let checkout=root.querySelector('.bpc-product-checkout-usd');
      if(!checkout){
        checkout=document.createElement('span');
        checkout.className='bpc-product-checkout-usd';
        root.appendChild(checkout);
      }
      if(checkout.dataset.bpcFxKey!==key){
        checkout.textContent=`${formatUsd(cents/100)} at checkout`;
        checkout.dataset.bpcFxKey=key;
      }
    });
  };

  const cartSelectors=[
    '.cart-item__price-wrapper > .price.price--end:not(.cart-item__old-price)',
    '.cart-item__price-wrapper .cart-item__discounted-prices .price.price--end:not(.cart-item__old-price)',
    '.cart-item__final-price',
    '.totals__subtotal-value'
  ].join(',');

  const getCartUsdCents=(element)=>{
    const saved=Number(element.dataset.bpcCartUsdCents);
    if(Number.isFinite(saved)&&saved>=0)return saved;
    const value=parseMoney(element.dataset.bpcOriginalUsdText||element.textContent);
    if(!Number.isFinite(value)||value<0)return null;
    const cents=Math.round(value*100);
    element.dataset.bpcCartUsdCents=String(cents);
    element.dataset.bpcOriginalUsdText=element.textContent.trim();
    return cents;
  };

  const renderCartPrice=(element)=>{
    const cents=getCartUsdCents(element);
    if(!Number.isFinite(cents))return;
    const key=priceKey(cents);
    if(element.dataset.bpcFxKey===key&&element.querySelector('.bpc-cart-price'))return;
    const usd=cents/100;
    element.innerHTML='';
    const wrapper=document.createElement('span');
    wrapper.className='bpc-cart-price';
    wrapper.innerHTML=`<span class="bpc-cart-price__usd">${formatUsd(usd)}</span><span class="bpc-cart-price__local">(approx. ${formatLocal(localFromUsd(usd))})</span>`;
    element.appendChild(wrapper);
    element.dataset.bpcFxKey=key;
    element.setAttribute('aria-label',`${formatUsd(usd)}; approximately ${formatLocal(localFromUsd(usd))} in local currency`);
  };

  const renderCartNotes=()=>{
    const text='Charged in USD. Local estimates include a 3% FX buffer and may vary by card issuer.';
    document.querySelectorAll('.cart__footer .totals,.drawer__footer .totals').forEach((totals)=>{
      let note=totals.nextElementSibling&&totals.nextElementSibling.classList.contains('bpc-checkout-currency-note')?totals.nextElementSibling:null;
      if(!note){
        note=document.createElement('p');
        note.className='bpc-checkout-currency-note';
        totals.insertAdjacentElement('afterend',note);
      }
      if(note.textContent!==text)note.textContent=text;
    });
  };

  const renderAll=()=>{
    renderQueued=false;
    if(rendering||!state.ready)return;
    rendering=true;
    document.querySelectorAll('.price-item[data-bpc-usd-cents]').forEach(renderPriceItem);
    renderProductHierarchy();
    document.querySelectorAll(cartSelectors).forEach(renderCartPrice);
    renderCartNotes();
    rendering=false;
  };

  const scheduleRender=()=>{
    if(renderQueued||rendering||!state.ready)return;
    renderQueued=true;
    requestAnimationFrame(renderAll);
  };

  const getSubtotalCents=(checkoutTarget)=>{
    const scope=checkoutTarget&&checkoutTarget.closest('#CartDrawer')?checkoutTarget.closest('#CartDrawer'):document;
    const element=scope.querySelector('.totals__subtotal-value')||document.querySelector('.totals__subtotal-value');
    return element?getCartUsdCents(element):null;
  };

  const modal=document.querySelector('[data-bpc-currency-modal]');
  const closeModal=()=>{
    if(!modal)return;
    modal.hidden=true;
    document.body.classList.remove('bpc-modal-open');
    pendingCheckout=null;
  };

  const openModal=(target)=>{
    if(!modal||!state.ready)return false;
    const cents=getSubtotalCents(target);
    if(!Number.isFinite(cents))return false;
    const usd=cents/100;
    modal.querySelector('[data-bpc-modal-usd]').textContent=formatUsd(usd);
    modal.querySelector('[data-bpc-modal-local]').textContent=formatLocal(localFromUsd(usd));
    modal.hidden=false;
    document.body.classList.add('bpc-modal-open');
    pendingCheckout=target;
    return true;
  };

  modal?.querySelectorAll('[data-bpc-modal-close]').forEach((button)=>button.addEventListener('click',closeModal));
  modal?.querySelector('[data-bpc-modal-continue]')?.addEventListener('click',()=>{
    const target=pendingCheckout;
    try{sessionStorage.setItem('bpcCurrencyNoticeSeen:v3','1');}catch(error){}
    closeModal();
    if(target){target.dataset.bpcCheckoutBypass='1';target.click();}
  });

  document.addEventListener('click',(event)=>{
    const target=event.target.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"],.cart__checkout-button');
    if(!target||!state.ready||target.dataset.bpcCheckoutBypass==='1')return;
    try{if(sessionStorage.getItem('bpcCurrencyNoticeSeen:v3')==='1')return;}catch(error){}
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal(target);
  },true);

  const start=(payload)=>{
    if(!payload||!validRate(payload.rate))return;
    state.rate=Number(payload.rate);
    state.rateDate=payload.rateDate||null;
    state.provider=payload.provider||null;
    state.ready=true;
    window.BpcCurrency={
      currency:state.currency,rate:state.rate,buffer:state.buffer,rateDate:state.rateDate,provider:state.provider,
      toLocal:(usd)=>localFromUsd(Number(usd)),formatLocal,formatUsd,render:renderAll
    };
    renderAll();
    if(!observer){observer=new MutationObserver(scheduleRender);observer.observe(document.body,{childList:true,subtree:true,characterData:true});}
    document.dispatchEvent(new CustomEvent('bpc:currency-ready',{detail:{currency:state.currency,rate:state.rate,buffer:state.buffer,rateDate:state.rateDate,provider:state.provider}}));
  };

  if(!validCurrency||currency==='USD')return;

  const cached=readCache();
  const age=cached?Date.now()-Number(cached.savedAt):Infinity;
  if(cached&&age<ttlMs){start(cached);return;}

  fetchRate().then((payload)=>{saveCache(payload);start(payload);}).catch(()=>{
    if(cached&&age<staleMaxMs)start(cached);
  });
})();